// @flow
import Cache from "../../utils/browser/Cache";
import Authenticate from "../../modularui/Authenticate";

import { reloadApplication } from "./Application";
import { startProgress, finishProgress } from "./ProgressIndicator";

import { push } from "../_router/RouterActions";
import { CHANGEPASSWORD_PATH } from "../../constants/Constants";

import type {
  SendAuthenticationErrorAction,
  ResetAuthErrorsAction,
  LoginSuccessAction,
  ThunkAction,
} from "../types";

/**
 * Send login failed action
 */
export const loginFailed = (
  errorMessage: string,
): SendAuthenticationErrorAction => sendAuthenticationError(errorMessage);

/**
 * Send authentication error action
 */
export const sendAuthenticationError = (
  errorMessage: string,
): SendAuthenticationErrorAction => ({
  type: "AUTHENTICATION_ERROR",
  payload: errorMessage,
});

/**
 * Resets any authentication errors
 */
export const resetAuthErrors = (): ResetAuthErrorsAction => ({
  type: "AUTHENTICATION_RESET_ERRORS",
});

/**
 * Send login success action
 */
export const loginSuccess = (): LoginSuccessAction => ({
  type: "AUTHENTICATION_SUCCESS",
});

/**
 * Send change password action
 */
export const changePassword = (): ThunkAction<> => (dispatch, getState) => {
  dispatch({
    type: "CHANGE_PASSWORD",
  });

  const isModal = getState().router.location?.state?.modal;
  const locationFrom = getState().router.location?.state?.from;
  return dispatch(
    push(CHANGEPASSWORD_PATH, {
      from: locationFrom ? locationFrom : getState().router.location,
      modal: isModal,
    }),
  );
};

/**
 */
export const login =
  (username: string, password: string): ThunkAction<> =>
  async (dispatch) => {
    dispatch(startProgress());

    try {
      const response = await new Authenticate().login(username, password);

      const application = await dispatch(reloadApplication());
      Cache.addItem("auth", true);

      if (application?.userMustChangePassword) {
        dispatch(changePassword());
      } else {
        dispatch(loginSuccess());
      }

      dispatch(finishProgress());
      return response;
    } catch (error) {
      if (error.id === "Error.ChangePasswordRequired") {
        await dispatch(reloadApplication());
        Cache.addItem("auth", true);
        dispatch(changePassword());
      } else {
        dispatch(loginFailed(error.id));
      }
      dispatch(finishProgress());
      return error;
    }
  };
